import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import { Edit } from "@mui/icons-material";
import axios from "../../../lib/axios";
import TextField from "@mui/material/TextField";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 500,
  width: "100%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  zIndex: 10,
};

export default function TechUpdateLesson(item) {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [descriptions, setDescription] = useState("");
  const Token = localStorage.getItem("accessToken");
  const [disabled, setDisabled] = useState(true);

  const config = {
    headers: {
      Authorization: Token,
    },
  };

  console.log(item.data);

  const updateTask = (e) => {
    e.preventDefault();
    const formData = {
      description: descriptions,
      id: item.data.homework_id,
      lesson_id: item.data.id,
    };

    axios
      .put("/homework", formData, config)
      .then((response) => {
        console.log(response.data);
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      });

    console.log(formData);
  };

  const updateLesson = (e) => {
    e.preventDefault();
    const formData = {
      id: item.data.id,
      lesson_name: title,
      lesson_date: date,
      description: "",
      group_id: localStorage.getItem("group_id"),
    };

    console.log(formData);

    axios
      .put("/lesson", formData, config)
      .then((response) => {
        console.log(response.data);
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (title && date) {
      setDisabled(false);
    }
  }, [disabled]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen}>
        <Edit />
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box component="form" sx={style} noValidate autoComplete="off">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                rowGap: "20px",
              }}
            >
              <TextField
                required
                label="Dars Nomi"
                style={{ width: "100%" }}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <TextField
                required
                // label="Dars sanasi"
                style={{ width: "100%" }}
                type="date"
                value={date}
                onChange={(e) => {
                  setDate(e.target.value);
                }}
              />
              <Button variant="contained" onClick={updateLesson}>
                Darsni yangilash
              </Button>
              <TextField
                label="Vazifa"
                required
                multiline
                rows={4}
                value={descriptions}
                onChange={(e) => setDescription(e.target.value)}
              />
              <Button variant="contained" id="createTask" onClick={updateTask}>
                Vazifani yangilash
              </Button>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
